<template>
  <!-- <pre>test data :: {{ seriesData }}</pre>  -->
  <AdminBackground v-if="responseData && responseData1">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PBTCare.png"
        alt="PBTCare"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>
        <div class="input-item">
          <AppDateTimePicker           
            v-model="dateRange"
            label="Tarikh"
            placeholder="Pilih Tarikh"
            :config="{ mode: 'range' }"
            class="app-date-picker custom-picker"
          />
        </div>      
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedMonth"
            label="Bulan"
            :items="months"
            placeholder="Pilih Bulan"
            chips
            class="app-date-picker"
          />
        </div>       
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states.map(s => (typeof s === 'object' ? s.name : s))"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>
      <h2>STATISTIK JUMLAH ADUAN MENGIKUT KATEGORI TAHUN {{ selectedYear }}</h2>
      <div class="chart-container">
        <div class="chart-wrapper">
          <StackedBarChart
            :x-axis-data="months"
            :series-data="seriesData"
            :legend-names="['Jumlah', 'Baharu', 'Dalam Tindakan', 'Selesai', 'LBK', 'Tiada Tindakan']"
          />
        </div>        
        <VCard>
          <VCardItem>
            <VCardTitle class="custom-title">
              Pecahan Keseluruhan Aduan
            </VCardTitle>
            <VCardTitle class="custom-title">
              Mengikut Status Tahun {{ selectedYear }}
            </VCardTitle>
          </VCardItem>
          <VCardText>
            <VList class="card-list">
              <p class="num">
                {{ numberWithCommas(jumlahKeseluruhan) || 0 }}
              </p>
              <p class="subtitle-badge badge-black">
                Jumlah Keseluruhan Tahun {{ selectedYear }}
              </p>
              <VListItem
                v-for="project in activeProjects"
                :key="project.title"
              >
                <VListItemTitle class="num">
                  {{ numberWithCommas(project.title) }}
                </VListItemTitle>
                <VListItemSubtitle
                  class="subtitle-badge"
                  :class="[project.badgeColor]"
                >
                  {{ project.subtitle }}
                </VListItemSubtitle>
                <template #append>
                  <div class="d-flex align-center gap-x-4">
                    <div style="inline-size: 4.875rem;">
                      <VProgressLinear
                        :model-value="project.stats"
                        :color="project.progressColor"
                        height="8"
                        rounded-bar
                        rounded
                      />
                    </div>
                    <span class="text-disabled">{{ project.stats }}%</span>
                  </div>
                </template>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </div>
      <h2>STATISTIK JUMLAH ADUAN MENGIKUT KATEGORI TAHUN {{ selectedYear }}</h2>    
      <div class="chart-wrapper">
        <Nightingale :chart-data="kategoriData" />
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <InspektoratMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref, toRaw, watch } from "vue"

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const seriesData = ref([
  { stack: 'one', data: []  },
  { stack: 'two', data: []  },
  { stack: 'two', data: []  },
  { stack: 'two', data: []  },
  { stack: 'three', data: []  },
  { stack: 'four', data: []  },
])

const { httpGet, numberWithCommas } = useHttpService()

const activeProjects = computed(() => {
  const total = jumlahKeseluruhan.value || 1 

  return [
    {
      title: dataStatus.value.Baharu || 0,
      subtitle: 'Baharu',
      stats: ((dataStatus.value.Baharu || 0) / total * 100).toFixed(0),
      progressColor: 'success',
      badgeColor: 'badge-blue',
    },
    {
      title: dataStatus.value["Dalam Tindakan"] || 0,
      subtitle: 'Dalam Tindakan',
      stats: ((dataStatus.value["Dalam Tindakan"] || 0) / total * 100).toFixed(0),
      progressColor: 'success',
      badgeColor: 'badge-orange',
    },
    {
      title: dataStatus.value.Selesai || 0,
      subtitle: 'Selesai',
      stats: ((dataStatus.value.Selesai || 0) / total * 100).toFixed(0),
      progressColor: 'success',
      badgeColor: 'badge-green',
    },
    {
      title: dataStatus.value.LBK || 0,
      subtitle: 'LBK',
      stats: ((dataStatus.value.LBK || 0) / total * 100).toFixed(0),
      progressColor: 'success',
      badgeColor: 'badge-purple',
    },
    {
      title: dataStatus.value["Tiada Tindakan"] || 0,
      subtitle: 'Tiada Tindakan',
      stats: ((dataStatus.value["Tiada Tindakan"] || 0) / total * 100).toFixed(0),
      progressColor: 'success',
      badgeColor: 'badge-red',
    },
  ]
})

const months = ref([
  "Semua Bulan",  
  "Januari",
  "Februari",
  "Mac",
  "April",
  "Mei",
  "Jun", 
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
])


const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref('2025')
const years = ref([])
const selectedMonth = ref('Semua Bulan') 
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')
const dateRange = ref([])
const responseData1 = ref(null)
const responseData = ref(null)
const tahunList = ref([])
const jumlahAduanList = ref([])
const jumlahKeseluruhan = ref(0)
const dataStatus = ref({})
const kategoriData = ref([])

async function loadDataFromApiAduan(
  year = selectedYear.value, 
  state = selectedsState.value, 
  pbtValue = selectedPbt.value,
) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`
   
    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const matchedState = states.value.find(s => s.name === state)
          if (matchedState) {
            queryParams += `&states[]=${matchedState.id}`
          }
        })
      } else {
        const matchedState = states.value.find(s => s.name === plainStates)
        if (matchedState) {
          queryParams += `&states[]=${matchedState.id}`
        }
      }
    }
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }
    const categories = Array.from({ length: 12 }, (_, i) => i + 1)

    // const urls = categories.map(
    //   month => `inspektorat/itegur?year=${year}&month=${month}${queryParams}`,
    // )

    // const response = await Promise.all(urls.map(url => httpGet(url)))

    const urls = categories.map(
  month => `https://jktgateway.kpkt.gov.my/api/inspektorat/itegur?year=${year}&month=${month}${queryParams}`
)

const response = await Promise.all(
  urls.map(async url => {
    const res = await fetch(url)
    return await res.json()
  })
)


    const jumlahData = new Array(12).fill(0)
    const baharuData = new Array(12).fill(0)
    const dalamData = new Array(12).fill(0)
    const selesaiData = new Array(12).fill(0)
    const lbkData = new Array(12).fill(0)
    const tiadaData = new Array(12).fill(0)
  
    if (response.states) {
      response.states.forEach(state => {
        if (state && state !== "Modified Pbt") {
          states.value.push({ name: state.name, id: state.id })
        }
      })
    }
    councils.value = response.councils || {}
    responseData1.value = response
  
    response.forEach((res, index) => {
      if (res.data.data_status) {
        const data = res.data.data_status


        // Extract individual values
        baharuData[index] = Number(data.Baharu || 0)
        dalamData[index] = Number(data["Dalam Tindakan"] || 0)
        selesaiData[index] = Number(data.Selesai || 0)
        lbkData[index] = Number(data.LBK || 0)
        tiadaData[index] = Number(data["Tiada Tindakan"] || 0)

        // Calculate jumlahData as the sum of all the above values
        jumlahData[index] = 
      baharuData[index] + 
      dalamData[index] + 
      selesaiData[index] + 
      lbkData[index] + 
      tiadaData[index]

      } else {
        console.warn(`No valid data for month ${index + 1}`)

        // Set all values to 0 if data is missing
        jumlahData[index] = 0
        baharuData[index] = 0
        dalamData[index] = 0
        selesaiData[index] = 0
        lbkData[index] = 0
        tiadaData[index] = 0
      }
    })

    seriesData.value = [
      { stack: 'one',  data: jumlahData },
      { stack: 'two', data: baharuData },
      { stack: 'two', data: dalamData },
      { stack: 'two', data: selesaiData },
      { stack: 'three',  data: lbkData },
      { stack: 'four',  data: tiadaData },
    ]

  } catch (err) {
    console.error("loadDataFromApiAduan failed:", err)
  }
}

async function loadDataFromApi(
  dateFrom = null, dateTo = null,
  month = selectedMonth.value, 
  year = selectedYear.value, 
  state = selectedsState.value, 
  pbtValue = selectedPbt.value,
) {
  try {
    const plainStates = toRaw(state)
    let monthIndex = months.value.indexOf(month)
    if (month === "Semua Bulan") monthIndex = "all"
    let queryParams = `month=${monthIndex}&year=${year === "Semua Tahun" ? "all" : year}`
    if (dateFrom && dateTo) {
      queryParams += `&date_start=${dateFrom}&date_end=${dateTo}`
    }
    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const matchedState = states.value.find(s => s.name === state)
          if (matchedState) {
            queryParams += `&states[]=${matchedState.id}`
          }
        })
      } else {
        const matchedState = states.value.find(s => s.name === plainStates)
        if (matchedState) {
          queryParams += `&states[]=${matchedState.id}`
        }
      }
    }
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }
    // const url = `inspektorat/itegur?${queryParams}`
    // const response = await httpGet(url)

  
    const url = `https://jktgateway.kpkt.gov.my/api/inspektorat/itegur?${queryParams}`
    const res = await fetch(url)
    const response = await res.json()

    if (!response || !response.data || !response.data.data_tahunan) {
      tahunList.value = []
      jumlahAduanList.value = []   
      
      return
    }
    years.value = ["Semua Tahun", ...response.years.sort((a, b) => b - a)]
    states.value = ["Semua Negeri", ...response.states.map(state => state.name)]
    if (response.states) {
      response.states.forEach(state => {
        if (state && state !== "Modified Pbt") {
          states.value.push({ name: state.name, id: state.id })
        }
      })
    }
    councils.value = response.councils || {}
    responseData.value = response
    let tahunData = Object.values(response.data.data_tahunan || {})
    if (!tahunData.length) {
      tahunList.value = []
      jumlahAduanList.value = []
      
      return
    }
    tahunData.sort((a, b) => a.tahun - b.tahun)
    if (year !== "Semua Tahun") {
      tahunData = tahunData.filter(item => item.tahun == year)
    }
    tahunList.value = tahunData.map(item => item.tahun)
    jumlahAduanList.value = tahunData.map(item => item.jumlah_aduan)
    jumlahKeseluruhan.value = jumlahAduanList.value.reduce((acc, val) => acc + val, 0)
    if (response.data.data_status) {
      dataStatus.value = response.data.data_status
    }
    if (response.data.data_kategori) {
      kategoriData.value = Object.entries(response.data.data_kategori).map(
        ([name, value]) => ({ name, value }),
      )
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state]) {
        pbt.value.push(...councils.value[state].map(council => council.value))
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value && councils.value[state]) { 
        pbt.value.push(...councils.value[state].map(council => council.value))
      } else {
        console.warn(`No councils found for state: ${state}`)
      }
    })
  }
}
onMounted(() => {
  const defaultDateFrom = '2025-01-01T00:00:00.000Z'
  const defaultDateTo = '2025-12-31T23:59:59.999Z'

  loadDataFromApi(defaultDateFrom, defaultDateTo, selectedMonth.value, '2025', selectedsState.value, selectedPbt.value)

  loadDataFromApiAduan()
})
watch(dateRange, newDateRange => {
  if (newDateRange && newDateRange.length === 24) {
    const dateFrom = newDateRange.substring(0, 10)
    const dateTo = newDateRange.substring(14)

    loadDataFromApi(dateFrom, dateTo)
  }
})
watch(seriesData, newValue => {
  // console.log('Updated seriesData:', newValue)
}, { deep: true })

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })
watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApiAduan(selectedYear.value, selectedsState.value, selectedPbt.value)
})
watch([selectedMonth, selectedYear, selectedsState, selectedPbt], () => {
  const [dateFrom, dateTo] = dateRange.value || [null, null]

  loadDataFromApi(dateFrom, dateTo, selectedMonth.value, selectedYear.value, selectedsState.value, selectedPbt.value)
})
</script>


<style scoped>
.card-list {
  --v-card-list-gap: 16px;
}
.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block-end: 20px;
}
.input-item {
  flex: 1;
  margin-inline-end: 15px;
}
.input-item:last-child {
  margin-inline-end: 0;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}
.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}
.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}
h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}
.chart-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.chart-wrapper {
  flex: 2;
  padding: 20px;
  background: rgba(255, 254, 254, 80%);
  border-radius: 10px;
}

.num {
  font-size: 1.4rem;
}
.subtitle-badge {
  font-size: 0.6rem;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 10px;
}
.badge-black { background-color: black; }
.badge-blue { background-color: #007bff; }
.badge-orange { background-color: #f39c12; }
.badge-green { background-color: #28a745; }
.badge-purple { background-color: #6f42c1; }
.badge-red { background-color: #f24e5e; }
.badge-dark-red { background-color: #a71d2a; }

@media (max-width: 1200px) {
  .content-wrapper,
 .chart-wrapper {
    padding: 15px;
  }
  h2 {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .top-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links {
    flex-direction: column;
    gap: 10px;
  }

  .logo {
    block-size: 25px;
  }
  h2 {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper,
 .chart-wrapper {
    padding: 10px;
  }
  h2 {
    font-size: 1rem;
  }
}
</style>
